import { PrimitiveUnit } from "./unit.model";

export class PaymentCondition extends PrimitiveUnit {
}
